import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetPilotConversationsQuery = (params = {}) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_PILOT_CONVERSATIONS, params],
    queryFn: () => api.get(API_ROUTES.GET_PILOT_CONVERSATIONS, { params }),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data?.data ?? [],
    grades: data?.data?.grades ?? {},
    causes: data?.data?.causes ?? {},
    fixed: data?.data?.fixed ?? 0,
    places: data?.data?.places ?? [],
    pagination: data?.data?.pagination ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};
